<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>
<template>
    <v-dialog v-model="openDialog" max-width="600px">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center">
                {{ title }}
            </v-card-title>
            <validation-observer ref="obs" v-slot="{ invalid }">
                    <validation-provider v-slot="{ errors }" :name="validateName" :rules="rules">
                        <v-card-title class="justify-center">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="createName" :placeholder="placeholder" :error-messages="errors" :counter="255" background-color="white"></v-text-field>
                        </v-card-title>
                    </validation-provider>
                <v-card-actions class="justify-center">
                    <v-btn width="30%" class="white--text mb-8" color="red" x-large @click="pushOk" :disabled="invalid">
                        {{ okBtn }}
                    </v-btn>
                    <v-btn width="30%" class="white--text mb-8 ml-8" color="blue-grey darken-1" x-large @click="openDialog = false">
                        {{ cnacelBtn }}
                    </v-btn>
                </v-card-actions>
            </validation-observer>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        dialog: Boolean,
        value: String,
        rules: {
            type: String,
            default: "required"
        },
        validateName: String,
        placeholder: String,
        title: String,
        okBtn: String,
        cnacelBtn: String,
    },
    computed: {
        openDialog: {
            get() {
                return this.dialog
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:dialog', value);
            }
        },
        createName: {
            get() {
                return this.value
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('input', value);
            }
        },
    },
    methods: {
        pushOk() {
            this.openDialog = false;
            this.$emit('clickOk');
        },
    },
}
</script>